export default __webpack_public_path__ + "static/media/forgot.e53c12c9.png";